// extracted by mini-css-extract-plugin
module.exports = {"resi":"resi_resi__14UX8","ourServices":"resi_ourServices__3XhEb","divider":"resi_divider__2NAQv","deliveryFlow":"resi_deliveryFlow__2EnFr"};